import { DescribeProperty } from '../../common';

export class Model3dDeleteResponse {
  @DescribeProperty({ description: 'The number of entries affected', type: 'number' })
  affected: number;

  @DescribeProperty({ description: 'The number of model3d inputs affected', type: 'number' })
  model3dInputsAffected?: number | null | undefined;

  @DescribeProperty({ description: 'The number of model3d outputs affected', type: 'number' })
  model3dOutputsAffected?: number | null | undefined;
}
